import { FC } from "react"
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material"
import { Userbot } from "../../interfaces"
import { useClientMeQuery } from "../../store"
import { getChainerError } from "./chainerError"
import { blockBackdropClose } from "../common/dialogUtils"
import { useUserbotWriteAccess } from "../../hooks"
import { SessionExportSection } from "./sessionExportSection"

interface IProps {
  client: Userbot.Client
  onClose: () => void
}

export const ClientMeView: FC<IProps> = ({ client, onClose }) => {
  const canWrite = useUserbotWriteAccess()
  const { data, isFetching, isError, error } = useClientMeQuery({
    id: client.id,
  })
  const cerr = isError ? getChainerError(error) : null

  return (
    <Dialog open onClose={blockBackdropClose(onClose)} maxWidth="sm" fullWidth>
      <DialogTitle>Профиль: {client.name}</DialogTitle>
      <DialogContent>
        {isFetching && <CircularProgress />}
        {cerr && (
          <Alert severity="error">
            {cerr.message}
            {cerr.category === "session-dead" && (
              <>
                <br />
                Удалите клиента и создайте нового через «Добавить сессию».
              </>
            )}
          </Alert>
        )}
        {data && (
          <Table size="small">
            <TableBody>
              {Object.entries(data).map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell sx={{ fontWeight: 600, width: "40%" }}>
                    {key}
                  </TableCell>
                  <TableCell>
                    {typeof value === "object"
                      ? JSON.stringify(value)
                      : String(value)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
        {canWrite && (
          <Stack spacing={2} mt={2}>
            <Divider />
            <Typography variant="subtitle1">Экспорт сессии</Typography>
            <SessionExportSection clientId={client.id} />
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Закрыть</Button>
      </DialogActions>
    </Dialog>
  )
}
